import { useRiskProfileSocialEconomicRequest } from './useRiskProfileSocialEconomicRequest'
import { useRiskProfileSocialEconomicQuery } from './useRiskProfileSocialEconomicQuery'
import type { PropertiesQueryParams } from '../types/riskProfileProperties.types'

export function useSocialHazardData(queryParams: PropertiesQueryParams | null) {
  const request = useRiskProfileSocialEconomicRequest({
    queryParams,
    widget: 'residentsByHazard',
  })
  const query = useRiskProfileSocialEconomicQuery(request)
  return { request, query }
}
